<div class="detail-dialog">
  <header class="dialog-header">
    <div class="title-group">
      <span class="product-name">{{ data.nombre }}</span>
      <div class="product-meta">
        <span class="code">
          <mat-icon>qr_code</mat-icon>
          {{ data.codigo }}
        </span>
        <span class="price">
          <mat-icon>attach_money</mat-icon>
          {{ precioUnitario | currency : 'MXN' : 'symbol' : '1.2-2' }}
        </span>
        <span class="stock" [class.low]="data.stock <= 0">
          <mat-icon>inventory</mat-icon>
          Stock: {{ data.stock }}
        </span>
      </div>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Cerrar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="dialog-divider"></div>

  <section class="dialog-body">
    <div class="info-row" *ngIf="data.contenido || data.unidadMedida">
      <mat-icon>straighten</mat-icon>
      <div>
        <h4>Presentación</h4>
        <p>{{ data.contenido || 'N/D' }} {{ data.unidadMedida || '' }}</p>
      </div>
    </div>

    <div class="info-block">
      <h4>Descripción</h4>
      <p>{{ descripcion }}</p>
    </div>

    <div class="info-block">
      <h4>Ingredientes</h4>
      <p>{{ ingredientes }}</p>
    </div>

    <div class="info-block">
      <h4>Beneficios</h4>
      <p>{{ beneficios }}</p>
    </div>

    <div class="info-block">
      <h4>Modo de uso</h4>
      <p>{{ modoUso }}</p>
    </div>
  </section>

  <footer class="dialog-footer">
    <button mat-stroked-button color="primary" (click)="close()">
      Cerrar
    </button>
  </footer>
</div>

